module.exports = __webpack_public_path__ + "img/WeTube.f955c67f.svg";